import { render } from "./search.vue?vue&type=template&id=ebec191c"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=ebec191c&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__